import "./bookingModalSkeleton.css";

export default function BookingModalSkeleton({ onClose }) {
	return (
		<div className="sf-book-overlay" onClick={onClose}>
			<div className="sf-book-modal" onClick={(e) => e.stopPropagation()}>

				{/* HEADER */}
				<div className="sf-skeleton-header-row">
					<div className="sf-skeleton-titlebar"></div>
					<div className="sf-skeleton-closebtn"></div>
				</div>

				<div className="sf-book-body">

					{/* WEEK RANGE */}
					<div className="sf-skeleton-weekrange"></div>

					{/* DAYS ROW */}
					<div className="sf-skeleton-days">
						{Array.from({ length: 7 }).map((_, i) => (
							<div className="sf-skeleton-day" key={i}>
								<div className="sf-skeleton-daytop"></div>
								<div className="sf-skeleton-daybar"></div>
							</div>
						))}
					</div>

					{/* PERIOD FILTERS */}
					<div className="sf-skeleton-timefilters">
						{Array.from({ length: 3 }).map((_, i) => (
							<div className="sf-skeleton-pill" key={i}></div>
						))}
					</div>

					{/* TIME SLOTS */}
					<div className="sf-skeleton-timeslots">
						{Array.from({ length: 7 }).map((_, i) => (
							<div key={i} className="sf-skeleton-slot"></div>
						))}
					</div>

					{/* STAFF SELECT */}
					<div className="sf-skeleton-section">
						<div className="sf-skeleton-line sf-skeleton-line-med"></div>
						<div className="sf-skeleton-select"></div>
					</div>

					{/* SERVICES */}
					<div className="sf-skeleton-section">
						<div className="sf-skeleton-line sf-skeleton-line-med"></div>
						<div className="sf-skeleton-select"></div>
					</div>

					{/* GUEST INFO */}
					<div className="sf-skeleton-section">
						<div className="sf-skeleton-line sf-skeleton-line-med"></div>
						<div className="sf-skeleton-input"></div>
						<div className="sf-skeleton-input"></div>
					</div>
				</div>

				{/* FOOTER */}
				<div className="sf-skeleton-footer">
					<div className="sf-skeleton-summary"></div>
					<div className="sf-skeleton-btn"></div>
				</div>
			</div>
		</div>
	);
}
